import React, { Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ICircledIcon from '@material-ui/icons/Info';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Snackbar from '@material-ui/core/Snackbar';
import Clear from '@material-ui/icons/Clear';
// import { ledgerNames } from '../constants/ledgerNames';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AutoComplete from 'material-ui/AutoComplete';
import DialogBox from './Dialogbox';
import { checkGstRcmApplicability, getEntities, getLedgerIds, getLedgerNames, getRecoverableAmountPercentage, getVendorTdsRate, updateInvoiceAmount } from '../utils/PaymentRequestApiUtils';
import data from '../component-data/paymentrequest-data/CostCenterDetails';
import { configurableTDS } from '../config/constants';
import userdata from '../config/jwt_token';
import { duplicateEntities } from '../constants/duplicateEntities';
import { Popover } from '@material-ui/core';
import { getGstTypeName } from '../utils/globalUtils';
import { Dialog, DialogContent } from '@material-ui/core'
import WaringIcon from '@material-ui/icons/Warning'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { isItemNameReadOnly } from '../utils/costCenterDisplay';

const errorText = 'This field is required';
class PaymentRequest extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cost_center_entries: {
        entries: [{ ...data }],
        deleted_entries: [],
        gst_type: '',
        gst_avail_type: '',
        is_recoverable: '',
        amount_recoverable: 0,
        billSub_amount_recoverable: 0,
        as_per_agreement: true,
        amt_recoverable_proof_file: null,
        amt_recoverable_proof_file_name: '',
        recoverable_amount_remarks: '',
      },
      isRemovedIndex: null,
      tds_slabs: [],
      entity_names: [],
      ledger_names: [],
      gst_slabs: [0, 5, 12, 18, 28, 40],
      gst_types: ['GST', 'IGST', 'UGST', 'SGST/CGST RCM', 'IGST RCM', 'NOT APPLICABLE'],
      gst_avail_types: ['GST AVAILMENT', 'GST NON-AVAILMENT', 'NOT APPLICABLE'],
      // disableGstSelect: false,
      showRcmAwarenessText: {
        message: 'You are adding a GST Ledger which is applicable as GST RCM. Please select GST type of RCM',
        ledger_indices: [],
      },
      showRcmAwarenessModal: false,
      currencies: ['INR', 'USD', 'EUR', 'GBP', 'JPY'],
      allowedFileSize: 5242880,
      snackOpen: false,
      snackText: '',
      dialogBox: false,
      dialogBoxText: '',
      dialogBoxStatus: '',
      proofErr: false,
      proofErrText: '',
      status: props.data.status ? props.data.status : 'onboard',
      isRemovedEntriesIndex: {},
      popOverConfig: {
        open: false,
        anchorEl: null,
        content: '',
        auxContent: '',
      },
      vendorLdcData: null,
      VendorDefaultortooltipText: "* Enter total amount you want to deduct from Vendor's Defaultor Amount.",
      VendorDefaultortooltipActionText:"* Once the payment changes have been saved you can't re-edit this amount and the amount will be deducted from Vendor's Defaultor Amount.",
      vendorLdcModal: false,
      vendorLdcModalData: [],
      showConfirmationDialog: false,
      confirmationDialogShown: false,
    }
  }

  handleChange = (props, index) => async (event, value) => {
    let entries = this.state.cost_center_entries.entries
    let is_gst_rcm = false;
    if (props === 'gst_type') {
      let entries
      let gst_avail_type
      if (event.target.value === 'GST') {
        entries = this.state.cost_center_entries.entries.map((data, index) => {
          let gst_splits = data.gst_splits.map((gst_data, gst_index) => {
            if (gst_data.gst_slab !== '') {
              let split_sgst_amount = this.calculateSGSTandCGST(gst_data.amount, gst_data.discount, gst_data.other_deduction, gst_data.gst_slab);
              let split_cgst_amount = this.calculateSGSTandCGST(gst_data.amount, gst_data.discount, gst_data.other_deduction, gst_data.gst_slab);
              let split_payable_amount = this.calculatePayableAmount(gst_data.amount, gst_data.discount, gst_data.other_deduction, split_sgst_amount + split_cgst_amount /* igst=0, ugst=0 when switching to GST */, gst_data.tds_deduction);
              gst_data = {
                ...gst_data,
                is_gst_rcm: is_gst_rcm,
                split_sgst_amount: split_sgst_amount,
                split_cgst_amount: split_cgst_amount,
                split_igst_amount: 0, split_ugst_amount: 0,
                split_payable_amount: split_payable_amount
              }
            }
            return gst_data
          })
          data.gst_splits = gst_splits
          let gstData = this.totalCostCenterGST(data)
          data = { ...data, ...gstData }
          return data
        })
      }
      else if (event.target.value === 'UGST') {

        entries = this.state.cost_center_entries.entries.map((data, index) => {
          let gst_splits = data.gst_splits.map((gst_data, gst_index) => {
            if (gst_data.gst_slab !== '') {
              let split_ugst_amount = this.calculateSGSTandCGST(gst_data.amount, gst_data.discount, gst_data.other_deduction, gst_data.gst_slab);
              let split_cgst_amount = this.calculateSGSTandCGST(gst_data.amount, gst_data.discount, gst_data.other_deduction, gst_data.gst_slab);
              let split_payable_amount = this.calculatePayableAmount(gst_data.amount, gst_data.discount, gst_data.other_deduction, split_cgst_amount + split_ugst_amount, gst_data.tds_deduction);
              gst_data = {
                ...gst_data,
                is_gst_rcm: is_gst_rcm,
                split_ugst_amount: split_ugst_amount,
                split_cgst_amount: split_cgst_amount,
                split_igst_amount: 0, split_sgst_amount: 0,
                split_payable_amount: split_payable_amount
              }
            }
            return gst_data
          })
          data.gst_splits = gst_splits
          let gstData = this.totalCostCenterGST(data)
          data = { ...data, ...gstData }
          return data
        })
      } else if (event.target.value === 'GST RCM' || event.target.value === 'IGST RCM' || event.target.value === 'SGST/CGST RCM') {
        entries = this.state.cost_center_entries.entries.map((data, index) => {
          let gst_splits = data.gst_splits.map((gst_data, gst_index) => {
            let payable_amount = this.calculatePayableAmountForRCM(parseFloat(gst_data.amount), 
            parseFloat(gst_data.discount), 
            parseFloat(gst_data.other_deduction), 
             0,
            parseFloat(gst_data.tds_deduction)
            );
            if (gst_data.gst_slab !== '') {
              gst_data = {
                ...gst_data,
                split_igst_amount: 0,
                split_cgst_amount: 0, split_ugst_amount: 0, split_sgst_amount: 0,
                split_payable_amount: payable_amount,
                is_gst_rcm: true,
              }
            }
            return gst_data
          })
          data.gst_splits = gst_splits
          let gstData = this.totalCostCenterGST(data)
          data = { ...data, ...gstData }
          return data
        })
      } else if (event.target.value === 'NOT APPLICABLE') {
        gst_avail_type = 'NOT APPLICABLE'
        entries = this.state.cost_center_entries.entries.map((data, index) => {
          let gst_splits = data.gst_splits.map((gst_data, gst_index) => {
            gst_data = {
              ...gst_data,
              gst_slab: 0,
              is_gst_rcm: is_gst_rcm,
              split_igst_amount: 0,
              split_sgst_amount: 0,
              split_cgst_amount: 0,
              split_ugst_amount: 0,
              split_payable_amount: this.calculatePayableAmount(gst_data.amount, gst_data.discount, gst_data.other_deduction, 0, gst_data.tds_deduction),
            }
            return gst_data
          })
          data.gst_splits = gst_splits

          let gstData = this.totalCostCenterGST(data)
          data = { ...data, ...gstData }
          return data
        })
      }
      else {
        entries = this.state.cost_center_entries.entries.map((data, index) => {
          let gst_splits = data.gst_splits.map((gst_data, gst_index) => {
            if (gst_data.gst_slab !== '') {
              let split_igst_amount = this.calculateIGST(gst_data.amount, gst_data.discount, gst_data.other_deduction, gst_data.gst_slab);
              let split_payable_amount = this.calculatePayableAmount(gst_data.amount, gst_data.discount, gst_data.other_deduction, split_igst_amount, gst_data.tds_deduction);
              gst_data = {
                ...gst_data,
                is_gst_rcm: is_gst_rcm,
                split_igst_amount: split_igst_amount,
                split_cgst_amount: 0,
                split_ugst_amount: 0, split_sgst_amount: 0,
                split_payable_amount: split_payable_amount
              }
            }
            return gst_data
          })
          data.gst_splits = gst_splits
          let gstData = this.totalCostCenterGST(data)
          data = { ...data, ...gstData }
          return data
        })
      }
      const recoverable_amount = this.calculateNewRecoverableAmount(entries);
      this.setState({ 
        cost_center_entries: { 
          ...this.state.cost_center_entries, 
          amount_recoverable: recoverable_amount,
          is_recoverable: recoverable_amount > 0,
          [props]: event.target.value, 
          entries: entries,
          gst_avail_type: gst_avail_type ? gst_avail_type : this.state.cost_center_entries.gst_avail_type
        }, 
        [props + 'ErrText']: '', 
        [props + 'Err']: false 
      })
    }
    else if (props === 'entity_name') {
      let gst_splits = entries[index].gst_splits;
      
      for(let gstIdx in gst_splits) {
        const recoverablePercentage = await this.checkRecoverablePercentage(event.value.Center_ID, gst_splits[gstIdx].ledger_name_id);
        gst_splits[gstIdx].is_recoverable = recoverablePercentage > 0;
        gst_splits[gstIdx].recoverable_percentage = recoverablePercentage;
      }
      entries[index] = {
        ...this.state.cost_center_entries.entries[index], 
        [props]: event.value.LOCALNAME,
        entity: event.value.Type, 
        city: event.value.CITY, 
        zolo_center_id: event.value.Center_ID, 
        Center_ID: event.value.Center_ID,
        gst_splits: gst_splits,
        [props + 'Err']: false, 
        [props + 'ErrText']: '',
      }
      const recoverable_amount = this.calculateNewRecoverableAmount(entries);
      this.setState({ 
        cost_center_entries: { 
          ...this.state.cost_center_entries, 
          amount_recoverable: recoverable_amount,
          is_recoverable: recoverable_amount > 0,
          entries: entries 
        } 
      })
    } 
    else if (props === 'defaultor_amount_deduction') {
      this.setState({ 
        cost_center_entries: { 
          ...this.state.cost_center_entries, 
          [props]: event.target.value,
          defaultor_amount_editable: true,
        }, 
        [props + 'Err']: false, 
        [props + 'ErrText']: '',
      })
    }
    else {
      this.setState({ cost_center_entries: { ...this.state.cost_center_entries, [props]: event.target.value }, [props + 'Err']: false, [props + 'ErrText']: '' })
    }

  }
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  calculateSGSTandCGST(amount, discount, other_deduction, gst_slab) {
    return (amount/* - discount - other_deduction*/) * (gst_slab / 200)
  }
  calculateIGST(amount, discount, other_deduction, gst_slab) {
    return (amount/* - discount - other_deduction*/) * (gst_slab / 100)
  }
  calculatePayableAmount(amount, discount, other_deduction, gst, tds_deduction) {
    let payable_amount = amount - discount - other_deduction + gst - tds_deduction;
    return payable_amount;
  }
  calculatePayableAmountForRCM(amount, discount, other_deduction, gst, tds_deduction) {
    let payable_amount = amount - discount - other_deduction + 0 - tds_deduction;
    return payable_amount;
  }
  calculateNewRecoverableAmount = (entries) => {
    let total_recovery_amount = 0;
    entries.map((data, index) => {
      data.gst_splits.map((gst_data, gst_index) => {
        let amount = (parseFloat(gst_data.amount) + (parseFloat(gst_data.gst_slab) * parseFloat(gst_data.amount) * 0.01)) * (gst_data.recoverable_percentage || 0) * 0.01;
        total_recovery_amount += amount;
      })
    });
    return total_recovery_amount;
  }

  async fetchVendorTdsRate(vendor_code, ledgerId) {
    let tds_rate = await getVendorTdsRate(vendor_code, ledgerId);
    if (tds_rate.flag && tds_rate.data) {
      return tds_rate.data;
    } else {
      return {
        tdsRate: 0,
      };
    }
  }

  handleTDSRateChange = async (ledgerId, vendorCode) => {
    const vendorTdsRate = await this.fetchVendorTdsRate(vendorCode, ledgerId);
    if (vendorTdsRate.tdsRate || vendorTdsRate.tds_section_name_id) {
      return vendorTdsRate;
    }
    return null;
  }

  getVendorLdcAmountLimit = (gst, vendorLdcDate) => {
    let ldc_amount_limit = '';
    if(vendorLdcDate) {
      const findIndex = vendorLdcDate.findIndex(vendor => vendor.tds_section_name_id === gst.tds_section_name_id);

      if(findIndex !== -1) {
        ldc_amount_limit = vendorLdcDate[findIndex].ldc_amount_limit;
      }
    }
    return ldc_amount_limit;
  }

  handleAllTDSRateChanges = async (ledgerId, vendorCode, gst, isTdsRate) => {
    //setting vendor_tds_rate
    let tds_slabs = (this.props.data.paymentDetails.tds_liability === 'Contracts' && this.props.data.paymentDetails.it_section_applicable) ? configurableTDS[this.props.data.paymentDetails.tds_liability][this.props.data.paymentDetails.it_section_applicable] : configurableTDS.standard;
    const tdsData = await this.handleTDSRateChange(ledgerId, vendorCode);
    const tdsRate =  (tdsData && tdsData.tdsRate) || 0;
    if (tdsRate || tdsRate === 0) {
      let findTds = tds_slabs.findIndex(tds => tds == tdsRate);
      if (findTds === -1) {
        tds_slabs.push(tdsRate);
      } else {
        tds_slabs[findTds] = tdsRate;
      }
    }
    // If user has manually changed the TDS rate, then don't update the TDS rate on component mount
    if (!isTdsRate) {
      gst.tds_slab = tdsRate;
      gst.tds_deduction = parseFloat((gst.amount * (tdsRate / 100)).toFixed(2));
      gst.tds_section_name_id = tdsData && tdsData.tds_section_name_id;
      const discount = gst.discount ? parseFloat(gst.discount) : 0;
      const otherDeduction = gst.other_deduction ? parseFloat(gst.other_deduction) : 0;
      const spitSGSTAmount = gst.split_sgst_amount ? parseFloat(gst.split_sgst_amount) : 0;
      const splitCGSTAmount = gst.split_cgst_amount ? parseFloat(gst.split_cgst_amount) : 0;
      const splitIGSTAmount = gst.split_igst_amount ? parseFloat(gst.split_igst_amount) : 0;
      const splitUGSTAmount = gst.split_ugst_amount ? parseFloat(gst.split_ugst_amount) : 0;
      const tdsDeduction = gst.tds_deduction ? parseFloat(gst.tds_deduction) : 0;

      gst.split_payable_amount = this.calculatePayableAmount(parseFloat(gst.amount), discount, otherDeduction, spitSGSTAmount + splitCGSTAmount + splitIGSTAmount + splitUGSTAmount, tdsDeduction);

      localStorage.setItem('tds_rate', 'false');
    }

    this.setState({
      tds_slabs: tds_slabs,
    })

    //Add Vendor LDC amount limit
    gst.ldc_amount_limit = this.getVendorLdcAmountLimit(gst, this.state.vendorLdcData);

    return gst;
  }

  calculateBillSubmissionAmount = (entries) => {
    let total_invoice_amount = 0;
    for (let entry of entries) {
      entry.gst_splits.map((gst) => {
        const gst_applicable = gst.is_gst_rcm ? 0 : gst.gst_slab;
        let amountwithGst = parseFloat(gst.amount) + (parseFloat(gst.amount) * (gst_applicable / 100))
        total_invoice_amount = parseFloat(total_invoice_amount) + parseFloat(amountwithGst);
      })
    };
    return total_invoice_amount;
  }

  showVendorLdcData = (vendor_ldc_data) => {
    if (vendor_ldc_data && vendor_ldc_data.length > 0) {
      const previewVendorData = [];
      for (let vendorLdcData of vendor_ldc_data) {
        if (vendorLdcData.ldc_amount_limit > 0) {
          previewVendorData.push({
            name: vendorLdcData.section_name,
            message: 'Vendor has LDC amount limit',
            renderVal: (
              <div>
                <span>{`LDC Limit: \u20B9 ${vendorLdcData.ldc_amount_limit}`}</span><br/>
                <span>LDC Rate: {vendorLdcData.ldc_rate}</span>
              </div>
            )
          })
        }
      }
      this.setState({
        vendorLdcModalData: previewVendorData,
      })
    }
  }

  async componentDidMount(props) {
    this.props.toggleBackdrop && this.props.toggleBackdrop(true);
    if (this.props.data.cost_center_entries !== undefined) {
      //checking for initial_invoice_amount
      let initial_invoice_amount = 0;
      if (this.props.data.paymentDetails.initial_invoice_amount == null) {
        initial_invoice_amount = this.calculateBillSubmissionAmount(this.props.data.cost_center_entries.entries);
        updateInvoiceAmount(this.props.data.paymentDetails.payment_request_id, initial_invoice_amount);
        this.props.data.paymentDetails.initial_invoice_amount = initial_invoice_amount;
      } else {
        initial_invoice_amount = this.props.data.paymentDetails.initial_invoice_amount
      }

      let CCE_Entries = [...this.props.data.cost_center_entries.entries];

      const ledgerNames = [];
      CCE_Entries.forEach(entry => {
        entry.gst_splits.forEach(split => {
          ledgerNames.push(split.ledger_name);
        });
      });

      const ledgerIds = await getLedgerIds({names: ledgerNames});
      if (ledgerIds && ledgerIds.data && ledgerIds.data.length > 0) {
        let rcmIdx = [];
        ledgerIds.data.map(async (ledger, index) => {
          const rcmApplicable = await this.checkGstRcmApplicable(ledger.id);
          if (rcmApplicable && rcmApplicable.types && rcmApplicable.types == 'GST RCM' || rcmApplicable.types == 'IGST RCM' || rcmApplicable.types == "SGST/CGST RCM") {
            rcmIdx.push(index);
          }
        })
        this.setState({
          showRcmAwarenessText: {
            ...this.state.showRcmAwarenessText,
            ledger_indices: rcmIdx,
          },
        })
      }
      this.showVendorLdcData(this.props.data.paymentDetails.vendor_ldc_data)
      for(let entryIdx in CCE_Entries) {
        for(let gstIdx in CCE_Entries[entryIdx].gst_splits) {
          if (ledgerIds.data) {
            let ledgerId = ledgerIds.data.find(ledger => ledger.name.toLowerCase() === CCE_Entries[entryIdx].gst_splits[gstIdx].ledger_name.toLowerCase());
            ledgerId = ledgerId ? ledgerId.id : null;
            if(ledgerId) {
              const split = CCE_Entries[entryIdx].gst_splits[gstIdx];
              // If the backend already included a recoverable_percentage from a stored
              // approver override (recovery_percentage in DB), skip the LCM API call.
              const hasStoredOverride = (split.recovery_percentage != null && parseFloat(split.recovery_percentage) >= 0)
                || (split.recoverable_percentage != null && split.recoverable_percentage > 0 && split.cost_to_owner != null);
              if (hasStoredOverride && !split._lcm_refreshed) {
                // Use whatever is already set — either recovery_percentage (0-1) or recoverable_percentage (0-100)
                if (split.recovery_percentage != null) {
                  const overridePct = Math.round(parseFloat(split.recovery_percentage) * 100);
                  split.is_recoverable = overridePct > 0;
                  split.recoverable_percentage = overridePct;
                }
                // else: recoverable_percentage already set by backend response
              } else {
                const recoverablePercentage = await this.checkRecoverablePercentage(CCE_Entries[entryIdx].Center_ID, ledgerId);
                split.is_recoverable = recoverablePercentage > 0;
                split.recoverable_percentage = recoverablePercentage;
              }
              split.ledger_name_id = ledgerId;
              const storedTdsRate = localStorage.getItem('tds_rate') ? JSON.parse(localStorage.getItem('tds_rate')) : false;
              const newGstData = await this.handleAllTDSRateChanges(ledgerId, this.props.data.paymentDetails.vendor_code, CCE_Entries[entryIdx].gst_splits[gstIdx], storedTdsRate);
              CCE_Entries[entryIdx].gst_splits[gstIdx] = newGstData;
            }
          }

          //Add Vendor LDC amount limit
          CCE_Entries[entryIdx].gst_splits[gstIdx].ldc_amount_limit = this.getVendorLdcAmountLimit(CCE_Entries[entryIdx].gst_splits[gstIdx], this.props.data.paymentDetails.vendor_ldc_data);
        }
      }
      
      this.setState({
        cost_center_entries: {
          ...this.state.cost_center_entries, ...this.props.data.cost_center_entries,
          entries: CCE_Entries,
          status: this.props.data.status,
          amount_recoverable: this.props.data.cost_center_entries.amount_recoverable,
          is_recoverable: this.props.data.cost_center_entries.amount_recoverable > 0,
          billSub_amount_recoverable: this.props.data.paymentDetails.billSub_recoverable_amount || 0,
        },
        initial_invoice_amount: initial_invoice_amount,
        vendorLdcData: this.props.data.paymentDetails.vendor_ldc_data,
      })
    } else {
      //setting vendor_tds_rate
      let tds_slabs = (this.props.data.paymentDetails.tds_liability === 'Contracts' && this.props.data.paymentDetails.it_section_applicable) ? configurableTDS[this.props.data.paymentDetails.tds_liability][this.props.data.paymentDetails.it_section_applicable] : configurableTDS.standard;
      this.showVendorLdcData(this.props.data.paymentDetails.vendor_ldc_data)
      this.setState({
        tds_slabs: tds_slabs,
        vendorLdcData: this.props.data.paymentDetails.vendor_ldc_data,
      })
      localStorage.setItem('tds_rate', JSON.stringify(false));
    }
    let selected_city = localStorage.getItem('selected_city');
    if ((!selected_city) && userdata.city.length > 0) {
      selected_city = userdata.city[0].city_name;
      localStorage.setItem('selected_city', selected_city);
    }

    const entitiesResp = await getEntities(selected_city);
    if (entitiesResp && entitiesResp.status === 'success') {
      if(selected_city == 'Hosur') {
        entitiesResp.data = entitiesResp.data.filter(entity => !duplicateEntities.includes(entity.LOCALNAME));
      }
      this.setState({ 
        entity_names: entitiesResp.data, 
        status: this.props.data.status,
        vendorLdcData: this.props.data.paymentDetails.vendor_ldc_data,
      }, () => this.props.toggleBackdrop && this.props.toggleBackdrop(false))
    }

    const ledgerNamesResp = await getLedgerNames();
    if (ledgerNamesResp && ledgerNamesResp.status === 'success') {
      this.setState({ 
        ledger_names: ledgerNamesResp.data,
        vendorLdcData: this.props.data.paymentDetails.vendor_ldc_data,
      }, () => this.props.toggleBackdrop && this.props.toggleBackdrop(false))
    }
    this.props.toggleBackdrop && this.props.toggleBackdrop(false)
  }
  totalCostCenterGST(data) {
    let payable_amount = 0, sgst_amount = 0, cgst_amount = 0, igst_amount = 0, ugst_amount = 0,
      tds_deduction = 0, deduction_others = 0, discount = 0, invoice_amount = 0
    data.gst_splits.map(data => {
      payable_amount = payable_amount + parseFloat(data.split_payable_amount)
      sgst_amount = sgst_amount + parseFloat(data.split_sgst_amount)
      cgst_amount = cgst_amount + parseFloat(data.split_cgst_amount)
      igst_amount = igst_amount + parseFloat(data.split_igst_amount)
      ugst_amount = ugst_amount + parseFloat(data.split_ugst_amount)
      tds_deduction = tds_deduction + parseFloat(data.tds_deduction)
      deduction_others = deduction_others + parseFloat(data.other_deduction)
      discount = discount + parseFloat(data.discount)
      invoice_amount = invoice_amount + parseFloat(data.amount)
    })
    return {
      payable_amount, sgst_amount, cgst_amount, igst_amount, ugst_amount,
      tds_deduction, deduction_others, discount, invoice_amount
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.data.cost_center_entries !== undefined) {
      this.setState({
        cost_center_entries: {
          ...this.state.cost_center_entries,
          ...nextProps.data.cost_center_entries, status: nextProps.data.status
        }
      })
    }
  }
  handleCloseDetails(index, event) {
    this.setState({
      dialogBox: true, dialogBoxText: 'Are you sure you want to remove the cost entry details',
      isRemovedIndex: index, dialogBoxStatus: 'deleteCostCenters'
    })
  }
  handleYes() {
    let entries = this.state.cost_center_entries.entries.filter((data, currentIndex) => this.state.isRemovedIndex !== currentIndex)
    if (this.state.status === 'onboard') {

      this.setState({ cost_center_entries: { ...this.state.cost_center_entries, entries: entries }, dialogBox: false, dialogBoxText: '' })
    }
    if (this.state.status === 'edit') {
      let deleted_entries = this.state.cost_center_entries.deleted_entries !== undefined ?
        this.state.cost_center_entries.deleted_entries : []

      this.setState({
        cost_center_entries: {
          ...this.state.cost_center_entries, entries: entries,
          deleted_entries: [...deleted_entries,
          this.state.cost_center_entries.entries[this.state.isRemovedIndex].cost_center_acc_entry_id]
        },
        dialogBox: false, dialogBoxText: '', isRemovedIndex: null, dialogBoxStatus: ''
      })
    }

  }
  handleNo() {
    this.setState({
      dialogBox: false, dialogBoxText: '',
      isRemovedIndex: null, isRemovedEntriesIndex: {}
    })
  }
  handleDetails(value) {
    if (value === 'next' && this.state.status === 'edit' && !this.state.confirmationDialogShown) {
      this.setState({ showConfirmationDialog: true });
      return;
    }
    let length = 0;
    if(!(this.props.data.cost_center_entries && this.props.data.cost_center_entries.defaultor_amount_deduction && this.props.data.cost_center_entries.defaultor_amount_deduction > 0)) {
      if(this.props.data.paymentDetails.defaultor_amount > 0 && this.state.cost_center_entries.defaultor_amount_deduction) {
        let deductedAmount = parseFloat(this.props.data.paymentDetails.defaultor_amount) - parseFloat(this.state.cost_center_entries.defaultor_amount_deduction);
        if(deductedAmount < 0) {
          this.setState({ snackOpen: true, snackText: 'Deducted amount is greater than defaultor amount' })
          return
        }
      }
    }

    // Check if total invoice amount is greater than LDC amount limit on Total Invoice Amount
    if(this.state.vendorLdcData && this.state.vendorLdcData.length > 0){
      let totalInvoiceAmount = {};
      for(let entry of this.state.cost_center_entries.entries) {
        for(let gst of entry.gst_splits) {
          const findIndex = this.state.vendorLdcData.findIndex(vendor => vendor.tds_section_name_id === gst.tds_section_name_id);
          if(findIndex !== -1) {
            totalInvoiceAmount[gst.tds_section_name_id] = (totalInvoiceAmount[gst.tds_section_name_id] || 0) + parseFloat(gst.amount);
          }
        }
      }

      for(let tdsSectionId in totalInvoiceAmount) {
        const ldcData = this.state.vendorLdcData.find(vendor => vendor.tds_section_name_id == tdsSectionId);

        const ldcAmountLimit = ldcData.ldc_amount_limit;

        const deductedAmount = parseFloat(ldcAmountLimit) - totalInvoiceAmount[tdsSectionId];

        if(deductedAmount < 0) {
          this.setState({ snackOpen: true, snackText: 'Total invoice amount is greater than LDC amount limit' })
          return
        }
      }
    }
    
    let entries = this.state.cost_center_entries.entries.map((data, index) => {
      let split_length = 0
      if (data.entity_name === '') {
        data = { ...data, entity_nameErrText: errorText }
      }
      if (isNaN(data.deduction_others) || data.deduction_others === '')
        data.deduction_others = 0;
      if (isNaN(data.discount) || data.discount === '')
        data.discount = 0;
      let gst_data = data.gst_splits.map(gst_data => {
        if (gst_data.amount === 0 || gst_data.amount === '') {
          gst_data = { ...gst_data, amountErrText: errorText, amountErr: true }
        }
        if (gst_data.gst_slab === '') {
          gst_data = { ...gst_data, gst_slabErrText: errorText, gst_slabErr: true }
        }
        if (gst_data.ledger_name === '') {
          gst_data = { ...gst_data, ledger_nameErrText: errorText }
        }
        if(gst_data.tds_slab === '' || gst_data.tds_slab == null) {
          gst_data = { ...gst_data, tds_slabErrText: errorText, tds_slabErr: true }
        }
        if (gst_data.amount && gst_data.gst_slab !== '' && gst_data.ledger_name !== '') {
          ++split_length
        }
        return gst_data
      })
      data.gst_splits = gst_data
      if (split_length === data.gst_splits.length && data.entity_name !== '') {
        length++
      }
      return data
    })
    if (this.state.cost_center_entries.entries.length === length) {
      data.gst_splits[0].ledger_nameSearchText = '';
      data.gst_splits[0].ledger_nameErrText = '';
      if (value === 'add') {
        this.setState({
          cost_center_entries: {
            ...this.state.cost_center_entries,
            entries: [...entries, { ...data }]
          }
        })
      }
      if (value === 'next')
        if (this.state.cost_center_entries.entries.length !== 0) {
          if (this.state.cost_center_entries.gst_type === '') {
            this.setState({ gst_typeErrText: errorText, gst_typeErr: true })
          }
          if (this.state.cost_center_entries.gst_avail_type === '') {
            let errorText = 'Please select an Applicable GST Availment Type';
            this.setState({ gst_avail_typeErrText: errorText, gst_avail_typeErr: true })
          }
          if (this.state.cost_center_entries.is_recoverable === '') {
            this.setState({ is_recoverableErrText: errorText, is_recoverableErr: true })
          }
          if (this.state.cost_center_entries.is_recoverable === true && !this.state.cost_center_entries.amount_recoverable) {
            this.setState({ amount_recoverableErrText: errorText, amount_recoverableErr: true })
          }
          if (this.state.cost_center_entries.is_recoverable === true && this.state.cost_center_entries.as_per_agreement === '') {
            this.setState({ as_per_agreementErrText: errorText, as_per_agreementErr: true })
          }

          let total_invoice_amount = 0, total_sgst_amount = 0, total_cgst_amount = 0, total_igst_amount = 0, total_ugst_amount = 0, total_gst_amount = 0;
          this.state.cost_center_entries.entries.map(data => {
            total_invoice_amount = total_invoice_amount + parseFloat(data.invoice_amount)
            total_sgst_amount = total_sgst_amount + parseFloat(data.sgst_amount)
            total_cgst_amount = total_cgst_amount + parseFloat(data.cgst_amount)
            total_igst_amount = total_igst_amount + parseFloat(data.igst_amount)
            total_ugst_amount = total_ugst_amount + parseFloat(data.ugst_amount)
            total_gst_amount = total_sgst_amount + total_cgst_amount + total_igst_amount + total_ugst_amount
          })

          for(let entries of this.state.cost_center_entries.entries) {
            for(let gst of entries.gst_splits) {
              if(gst.tds_slab === '' || gst.tds_slab == null) {
                this.setState({ snackOpen: true, snackText: 'Please select TDS slab' })
                return
              }
            }
          }

          let initialTotalInvoiceAmt = 0;
          if (this.state.status === 'edit') {
            if (this.props.data.paymentDetails.initial_invoice_amount) {
              initialTotalInvoiceAmt = parseFloat(this.props.data.paymentDetails.initial_invoice_amount);
            } else {
              initialTotalInvoiceAmt = this.state.initial_invoice_amount;
            }
            const tpa_plus5 = initialTotalInvoiceAmt + 5;
            const tpa_minus5 = initialTotalInvoiceAmt - 5;
            const newTotalInvoiceAmt = this.calculateBillSubmissionAmount(this.state.cost_center_entries.entries)
            if (tpa_minus5 >= newTotalInvoiceAmt || newTotalInvoiceAmt >= tpa_plus5) {
              this.setState({ snackOpen: true, snackText: 'Total invoice amount is not equal to total payable amount' })
              return
            }
          } else if (this.state.status === 'onboard') {
            initialTotalInvoiceAmt = this.calculateBillSubmissionAmount(this.state.cost_center_entries.entries);
          }
          //Update the initial invoice amount in paymentDetails object
          this.props.data.paymentDetails.initial_invoice_amount = initialTotalInvoiceAmt;

          if ((total_invoice_amount + total_gst_amount) < this.state.cost_center_entries.amount_recoverable) {
            this.setState({ snackOpen: true, snackText: 'Amount recoverable is greater than total invoice amount' })
            return
          }
          if (this.state.cost_center_entries.gst_type !== '' && this.state.cost_center_entries.gst_avail_type !== '' && this.state.cost_center_entries.is_recoverable !== ''
            && (this.state.cost_center_entries.is_recoverable === false || this.state.cost_center_entries.amount_recoverable)) {
            let ledgerCheck = 0;
            this.state.cost_center_entries.entries.every((entry, index) => {
              if (entry.gst_splits.length === 0) {
                ledgerCheck = index + 1;
                return false;
              }
              else
                return true;
            })
            if (ledgerCheck === 0){
              let isGstTypeRcm = this.state.cost_center_entries.gst_type === 'IGST RCM' || this.state.cost_center_entries.gst_type === 'SGST/CGST RCM';
              if (this.state.showRcmAwarenessText.ledger_indices.length > 0 && !isGstTypeRcm) {
                this.setState({
                  showRcmAwarenessModal: true,
                });
                return true;
              }
              this.props.handleNext(this.state.cost_center_entries)
            }
            else
              this.setState({ snackOpen: true, snackText: `At least one Ledger Entry should be present in Cost Center: ${ledgerCheck} ` })
          }
        }
        else {
          this.setState({ snackOpen: true, snackText: 'There should be atleast one cost center entry' })
        }
    }
    else {
      this.setState({ cost_center_entries: { ...this.state.cost_center_entries, entries: entries } })
    }
  }
  handleUpdateInput(index, props, gst_index, searchText) {
    let entries = this.state.cost_center_entries.entries
    if (props === 'ledger_name') {
      let gst_splits = entries[index].gst_splits
      gst_splits[gst_index] = { ...gst_splits[gst_index], [props + "SearchText"]: searchText, 'ledger_name': '', "ledger_nameErr": true, 'ledger_nameErrText': "This field is required" }
      entries[index].gst_splits = gst_splits
    }
    else if (props === 'entity_nameSearchText') {
      entries[index] = { ...this.state.cost_center_entries.entries[index], [props]: searchText, 'entity_name': '', 'entity_nameErr': true, 'entity': "", "entity_nameErrText": "This field is required" }
    }
    else {
      entries[index] = { ...this.state.cost_center_entries.entries[index], [props]: searchText }
    }
    const recoverable_amount = this.calculateNewRecoverableAmount(entries);
    this.setState({
      entries,
      cost_center_entries: {
        ...this.state.cost_center_entries,
        amount_recoverable: recoverable_amount,
        is_recoverable: recoverable_amount > 0,
      }
    });
  }
  handleClear() {
    this.setState({
      cost_center_entries: {
        entries: [data],
        deleted_entries: [],
      },
    })
  }
  amtRecoverableFileHandler = (event, value) => {
    this.setState({
      cost_center_entries: {
        ...this.state.cost_center_entries,
        amt_recoverable_proof_file: null,
        amt_recoverable_proof_file_name: ''
      },
      proofErrText: '', proofErr: false
    });
    if (event.target.files[0].size <= this.state.allowedFileSize) {
      this.setState({
        cost_center_entries: {
          ...this.state.cost_center_entries,
          amt_recoverable_proof_file: event.target.files[0],
          amt_recoverable_proof_file_name: event.target.files[0].name
        }
      })
    }
    else {
      this.setState({ proofErrText: `Uploaded file exceeds ${this.state.allowedFileSize / 1024 / 1024} MB`, proofErr: true });
      return false;
    }
  }
  addGST(index) {
    let entries = this.state.cost_center_entries.entries
    let gst_split = {
      amount: 0,
      split_sgst_amount: 0,
      split_cgst_amount: 0,
      split_igst_amount: 0,
      split_ugst_amount: 0,
      gst_slab: 0,
      tds_slab: '',
      tds_deduction: 0,
      other_deduction: 0,
      discount: 0,
      ledger_name: '',
      split_payable_amount: 0,
      quantity: 0,
      rate: 0,
      ldc_amount_limit: 0,
      item_name: '',
      item_description: '',
      currency: 'INR',
      ledger_name_text: '',
      ledger_nameSearchText: '',
      ledger_nameErr: false,
      ledger_nameErrText: '',
      is_recoverable: false,
      recoverable_percentage: 0,
      is_gst_rcm: (this.state.cost_center_entries.gst_type === 'GST RCM' || this.state.cost_center_entries.gst_type === 'IGST RCM' || this.state.cost_center_entries.gst_type === 'SGST/CGST RCM') ? true : false,
      hsn: '',
      sac: '',
    }
    entries[index].gst_splits = [...entries[index].gst_splits, gst_split]
    this.setState({ cost_center_entries: { ...this.state.cost_center_entries, entries } })
  }
  /*checks if GST type is selected*/
  handleGstTypeCheck(props, index, gst_index, event) {
    /*make use select GST type*/
    if (this.state.cost_center_entries.gst_type === '' || this.state.cost_center_entries.gst_type === null) {
      let errorText = 'Please select an Applicable GST Type';
      this.setState({ gst_typeErrText: errorText, gst_typeErr: true });
    } else if (this.state.cost_center_entries.gst_avail_type === '' || this.state.cost_center_entries.gst_avail_type === null) {
      let errorText = 'Please select an Applicable GST Availment Type';
      this.setState({ gst_avail_typeErrText: errorText, gst_avail_typeErr: true });
    }
    /*gst type already selected*/
    else
      this.handleGstBreakup(props, index, gst_index, event);
  }

  checkRecoverablePercentage = async (centerId, ledgerNameId) => {
    const response = await getRecoverableAmountPercentage(ledgerNameId, centerId);
    if (response && response.status === 'success') {
      return parseInt(response.data.recoverable_amount * 100);
    } else {
      return 0;
    }
  }

  async checkGstRcmApplicable(ledger_name_id) {
    const response  = await checkGstRcmApplicability(ledger_name_id)
    if (response.flag) {
      return response.data[0]
    } else {
      return {}
    }
  }

  handleRcmLedgerIndices(isRcm, index) {
    //! Function to handle ledger indices (Index of GST Splits not Ledger Ids) for rcm awareness modal
    let currentIndices = this.state.showRcmAwarenessText.ledger_indices;
    if (isRcm) {
      if (currentIndices.indexOf(index) === -1) {
        currentIndices.push(index);
      }
    } else {
      if (currentIndices.indexOf(index)!== -1) {  
        currentIndices.splice(currentIndices.indexOf(index), 1);
      }
     }
     return currentIndices;

  }

  handleClose = () => {
    this.setState({ showRcmAwarenessModal: false })
  }

  async handleGstBreakup(props, index, gst_index, event) {
    let entries = [...this.state.cost_center_entries.entries]
    let gst_splits = [...entries[index].gst_splits]
    // let gst_type;
    let gst_slab;
    let isRcm = false;
    if (props === 'tds_slab') {
      localStorage.setItem('tds_rate', JSON.stringify(true));
    }
    if (props === 'ledger_name') {
      // check whether the GST type is RCM or not
      const rcmApplicable = await this.checkGstRcmApplicable(event.id);

      if (rcmApplicable && rcmApplicable.types && (rcmApplicable.types == 'IGST RCM' || rcmApplicable.types == 'SGST/CGST RCM' || rcmApplicable.types == 'GST RCM')) {
        isRcm = true;
      }
      if (rcmApplicable && rcmApplicable.types && (rcmApplicable.types == 'IGST RCM' || rcmApplicable.types == 'SGST/CGST RCM' || rcmApplicable.types == 'GST RCM')) {
        // gst_type = rcmApplicable.types;
        gst_slab = rcmApplicable.gst_percentage;
      } else {
        if (this.state.cost_center_entries.gst_type === 'NOT APPLICABLE') {
          gst_slab = 0; 
        } else {
          gst_slab = '';
        }
        // if (this.state.cost_center_entries.gst_type === '' || this.state.cost_center_entries.gst_type === 'GST RCM') {
        //   gst_type = '';
        // } else{
        //   gst_type = this.state.cost_center_entries.gst_type;
        // }
      }

      const recoverablePercentage = await this.checkRecoverablePercentage(entries[index].Center_ID, event.id);

      gst_splits[gst_index] = {
        ...gst_splits[gst_index],
        ledger_name: event.value,
        ledger_name_text: event.value,
        ledger_name_id: event.id,
        is_recoverable: recoverablePercentage > 0,
        recoverable_percentage: recoverablePercentage,
        [props + 'ErrText']: ''
      }
      const storedTdsRate = localStorage.getItem('tds_rate') ? JSON.parse(localStorage.getItem('tds_rate')) : false;
      const newGstData = await this.handleAllTDSRateChanges(event.id, this.props.data.paymentDetails.vendor_code, gst_splits[gst_index], storedTdsRate);
      gst_splits[gst_index] = newGstData;
      entries[index].gst_splits = gst_splits
      entries[index].gst_splits[gst_index].gst_slab = gst_slab ? parseInt(gst_slab) : gst_slab;
      entries[index].gst_splits[gst_index].is_gst_rcm = isRcm || (this.state.cost_center_entries.gst_type === 'GST RCM' || this.state.cost_center_entries.gst_type === 'IGST RCM' || this.state.cost_center_entries.gst_type === 'SGST/CGST RCM');
      const recoverable_amount = this.calculateNewRecoverableAmount(entries);

      this.setState({
        cost_center_entries: {
          ...this.state.cost_center_entries,
          amount_recoverable: recoverable_amount,
          is_recoverable: recoverable_amount > 0,
          entries,
          // gst_type: gst_type
        },
        showRcmAwarenessText: {
          ...this.state.showRcmAwarenessText,
          ledger_indices: this.handleRcmLedgerIndices(isRcm, gst_index)
        }
        // disableGstSelect: gst_type == "GST RCM" ? true : false
      })
    }
    else {
      let numberFields = ['amount', 'other_deduction', 'discount'];
      if (numberFields.indexOf(props) !== -1) {
        let re = new RegExp('^[+]?([0-9]+(?:[\\.][0-9]*)?|\\.[0-9]+)$');
        let inputVal = "" + event.target.value;
        if ((!re.test(inputVal) && inputVal !== '') || isNaN(inputVal))
          return false;
        if (inputVal === '')
          inputVal = 0;
        gst_splits[gst_index] = { ...gst_splits[gst_index], [props]: inputVal, [props + 'ErrText']: '', [props + 'Err']: false };
      }
      else
        gst_splits[gst_index] = { ...gst_splits[gst_index], [props]: event.target.value, [props + 'ErrText']: '', [props + 'Err']: false }
      this.props.data.paymentDetails.tds_rate = gst_splits[gst_index].tds_slab;
      if (gst_splits[gst_index].gst_slab !== '' && this.state.cost_center_entries.gst_type !== '') {
        if (this.state.cost_center_entries.gst_type === 'GST') {
          gst_splits[gst_index] = {
            ...gst_splits[gst_index],
            split_sgst_amount: this.calculateSGSTandCGST(gst_splits[gst_index].amount, gst_splits[gst_index].discount, gst_splits[gst_index].other_deduction, gst_splits[gst_index].gst_slab),
            split_cgst_amount: this.calculateSGSTandCGST(gst_splits[gst_index].amount, gst_splits[gst_index].discount, gst_splits[gst_index].other_deduction, gst_splits[gst_index].gst_slab),
            split_igst_amount: 0, split_ugst_amount: 0
          }
        }
        else if (this.state.cost_center_entries.gst_type === 'UGST') {

          gst_splits[gst_index] = {
            ...gst_splits[gst_index],
            split_cgst_amount: this.calculateSGSTandCGST(gst_splits[gst_index].amount, gst_splits[gst_index].discount,
              gst_splits[gst_index].other_deduction, gst_splits[gst_index].gst_slab),
            split_ugst_amount: this.calculateSGSTandCGST(gst_splits[gst_index].amount, gst_splits[gst_index].discount,
              gst_splits[gst_index].other_deduction, gst_splits[gst_index].gst_slab),
            split_sgst_amount: 0, split_igst_amount: 0
          }
        } else if(this.state.cost_center_entries.gst_type === 'GST RCM' || this.state.cost_center_entries.gst_type === 'IGST RCM' || this.state.cost_center_entries.gst_type === 'SGST/CGST RCM') {
          gst_splits[gst_index] = {
            ...gst_splits[gst_index],
          }
        } else if (this.state.cost_center_entries.gst_type === 'NOT APPLICABLE') {
          // When gst is not applicable, set gst slab to 0
          gst_splits[gst_index] = {
            ...gst_splits[gst_index],
            gst_slab: 0
          }
        }
        else {

          gst_splits[gst_index] = {
            ...gst_splits[gst_index],
            split_igst_amount: this.calculateSGSTandCGST(gst_splits[gst_index].amount, gst_splits[gst_index].discount,
              gst_splits[gst_index].other_deduction, gst_splits[gst_index].gst_slab) * 2, split_sgst_amount: 0,
            split_cgst_amount: 0, split_ugst_amount: 0
          }
        }
      }
      if (gst_splits[gst_index].tds_slab !== '') {
        gst_splits[gst_index] = { ...gst_splits[gst_index], tds_deduction: (gst_splits[gst_index].amount/* - gst_splits[gst_index].discount - gst_splits[gst_index].other_deduction*/) * (gst_splits[gst_index].tds_slab / 100) }
      }
      let payableAmount = this.calculatePayableAmount(gst_splits[gst_index].amount
        , gst_splits[gst_index].discount, gst_splits[gst_index].other_deduction,
        gst_splits[gst_index].split_sgst_amount + gst_splits[gst_index].split_cgst_amount +
        gst_splits[gst_index].split_igst_amount + gst_splits[gst_index].split_ugst_amount,
        gst_splits[gst_index].tds_deduction
      );
      if (payableAmount < 0) {
        /*show error*/
        this.setState({ snackText: "Deductions and Discounts can't be greater than Amount", snackOpen: true });
        return false;
      }
      gst_splits[gst_index] = {
        ...gst_splits[gst_index], split_payable_amount: payableAmount
      }
      entries[index].gst_splits = gst_splits
      let gstData = this.totalCostCenterGST(entries[index])
      entries[index] = {
        ...this.state.cost_center_entries.entries[index], ...gstData
      }
      let updatedData = { 
        cost_center_entries: { 
          ...this.state.cost_center_entries, 
          entries,
        } 
      }
      if (props !== 'tds_slab') {
        // Calculate recoverable amount
        const recoverable_amount = this.calculateNewRecoverableAmount(entries);
        updatedData.cost_center_entries.amount_recoverable = recoverable_amount;
        updatedData.cost_center_entries.is_recoverable = recoverable_amount > 0;
      }
      this.setState(updatedData)
    }
  }
  deleteEntries(index, gst_index) {
    this.setState({
      dialogBox: true, dialogBoxText: 'Are you sure you want to remove the entry',
      dialogBoxStatus: 'deleteEntries', isRemovedEntriesIndex: { index, gst_index }
    })
  }
  removeEntries() {
    let entries = [...this.state.cost_center_entries.entries]
    let gst_split = [...entries[this.state.isRemovedEntriesIndex.index].gst_splits]
    let deleted_gst_split = entries[this.state.isRemovedEntriesIndex.index].deleted_gst_splits ? [...entries[this.state.isRemovedEntriesIndex.index].deleted_gst_splits] : []
    if (this.state.status === 'edit') {
      let deleted_entries = [...entries[this.state.isRemovedEntriesIndex.index] !== undefined ?
        entries[this.state.isRemovedEntriesIndex.index] : []]
      deleted_gst_split.push(...deleted_entries, gst_split[this.state.isRemovedEntriesIndex.gst_index].id)
      entries[this.state.isRemovedEntriesIndex.index].deleted_gst_splits = deleted_gst_split
    }
    gst_split.splice(this.state.isRemovedEntriesIndex.gst_index, 1)
    entries[this.state.isRemovedEntriesIndex.index].gst_splits = gst_split
    let gstData = this.totalCostCenterGST(entries[this.state.isRemovedEntriesIndex.index])
    entries[this.state.isRemovedEntriesIndex.index] = {
      ...this.state.cost_center_entries.entries[this.state.isRemovedEntriesIndex.index], ...gstData
    }
    this.setState({
      cost_center_entries: { ...this.state.cost_center_entries, entries }, isRemovedEntriesIndex: {},
      dialogBox: false, dialogBoxText: '', dialogBoxStatus: ''
    })
  }

  isVendorDefaultorAmount = () => {
    return this.props.data && this.props.data.paymentDetails && this.props.data.paymentDetails.defaultor_amount > 0;
  }

  openInfoPopOver = (infoType) => (event) => {
    switch(infoType){
      case "Vendor":
        this.setState({
          popOverConfig: {
            ...this.state.popOverConfig,
            open: Boolean(event.currentTarget),
            anchorEl: event.currentTarget,
            content: this.state.VendorDefaultortooltipText,
            auxContent: this.state.VendorDefaultortooltipActionText
          }
        })
        break;
      default: break;
    }
  }
  handlePopOverClose = () => {
    this.setState({
      popOverConfig: {
        ...this.state.popOverConfig,
        open: false,
        anchorEl: null,
      }
    })
  }

  handleDisableDefaultorAmount = () => {
    if((this.props.data.cost_center_entries && this.props.data.cost_center_entries.defaultor_amount_deduction > 0) && !this.state.cost_center_entries.defaultor_amount_editable) {
      return true;
    }
    return false;
  }

  handleCloseConfirmationDialog = () => {
    this.setState({ showConfirmationDialog: false, confirmationDialogShown: true });
  }

  render() {
    let isGstTypeRcm = this.state.cost_center_entries.gst_type === 'IGST RCM' || this.state.cost_center_entries.gst_type === 'SGST/CGST RCM';
    return (
      <MuiThemeProvider>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <div style={{display: 'flex', gap: '5rem'}}>
            <FormControl margin='normal'>
              <InputLabel htmlFor="gst_type">*Applicable GST type</InputLabel>
              <Select
                value={this.state.cost_center_entries.gst_type}
                onChange={this.handleChange('gst_type')}
                error={this.state.gst_typeErr}
                inputProps={{
                  name: 'Applicable GST type',
                  id: 'gst_type',
                }}
                style={{ width: '250px', textAlign: 'left' }}
                // disabled={this.state.disableGstSelect}
              >
                {
                  this.state.gst_types.map(gst_type => {
                    return <MenuItem value={gst_type}>{getGstTypeName(gst_type)}</MenuItem>
                  })
                }
              </Select>
              <FormHelperText style={{ color: 'red' }}>{this.state.gst_typeErrText}</FormHelperText>
              {this.state.showRcmAwarenessText.ledger_indices.length > 0 && !isGstTypeRcm && (
              <WaringIcon 
                style={{ 
                  color: '#FF0000',
                  position: 'absolute', 
                  right: '-1.7rem', 
                  bottom: '1rem',
                  cursor: 'pointer'
                }} 
                onClick={() => this.setState({ showRcmAwarenessModal: true })}
              />
            )}
            </FormControl>
            <FormControl margin='normal'>
              <InputLabel htmlFor="gst_avail_type">*GST Availment</InputLabel>
              <Select
                value={this.state.cost_center_entries.gst_avail_type}
                onChange={this.handleChange('gst_avail_type')}
                error={this.state.gst_avail_typeErr}
                inputProps={{
                  name: 'GST Availment',
                  id: 'gst_avail_type',
                }}
                style={{ width: '250px', textAlign: 'left' }}
                disabled={this.state.cost_center_entries.gst_type == 'NOT APPLICABLE'}
              >
                {
                  this.state.gst_avail_types.map(gst_avail_type => {
                    return <MenuItem value={gst_avail_type}>{gst_avail_type}</MenuItem>
                  })
                }
              </Select>
              <FormHelperText style={{ color: 'red' }}>{this.state.gst_avail_typeErrText}</FormHelperText>
            </FormControl>
          </div>
          {this.isVendorDefaultorAmount() ? (
            <TextField
              label="Vendor Defaultor Amount"
              value={this.props.data.paymentDetails.defaultor_amount}
              margin='normal'
              style={{ width: '250px' }}
              disabled={true}
              inputProps={{ style: { color: '#FF0000' } }}
            />
          ) : null}
        {this.props.data.paymentDetails && this.props.data.paymentDetails.vendor_ldc_data && this.props.data.paymentDetails.vendor_ldc_data.length > 0 && <Button variant="contained" color="primary" onClick={() => this.setState({ vendorLdcModal: true })}>
            View LDC Data
          </Button>}
        </div>
        {this.state.cost_center_entries.entries.map((data, index) => {
          return (<ExpansionPanel defaultExpanded key={`key ${index}`}>
            <ExpansionPanelSummary style={{ backgroundColor: 'lightgray' }} expandIcon={<ExpandMoreIcon />}>
              <Typography >Cost Center Details {index + 1}</Typography>
              <Clear style={{ position: 'absolute', right: '22px', height: '18px' }} onClick={this.handleCloseDetails.bind(this, index)} />
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div style={{ marginLeft: '10px' }}>
                <AutoComplete
                  hintText="Entity"
                  errorText={data.entity_nameErrText}
                  value={data.entity_name}
                  errorStyle={{ fontSize: '12px', color: 'red' }}
                  floatingLabelText='*Entity Name'
                  searchText={data.entity_nameSearchText}
                  onUpdateInput={this.handleUpdateInput.bind(this, index, 'entity_nameSearchText', index)}
                  onNewRequest={this.handleChange('entity_name', index)}
                  dataSource={this.state.entity_names.map((val, index) => {
                    return {
                      text: `${val.LOCALNAME} (${val.Type}), ${val.CITY}`,
                      value: (
                        val
                      )
                    }
                  })}
                  filter={AutoComplete.caseInsensitiveFilter}
                  textFieldStyle={{ width: '520px' }}
                  listStyle={{ width: 'auto', height: '300px' }}
                  openOnFocus={true}
                  underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)', width: '520px' }}
                  floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                // disabled={this.state.status === 'edit'}
                />
                {data.gst_splits.map((gst_data, gst_index) => {
                  return (
                    <Fragment>
                      <div style={{ display: 'grid', gridTemplateColumns: '30px 94% auto', position: 'relative' }} key={`key ${gst_index}`}>
                        {/* {(gst_index + 1 === data.gst_splits.length && this.state.status != 'edit') ? */}
                        {(gst_index + 1 === data.gst_splits.length) ?
                          <i className="fa fa-plus-circle" aria-hidden="true" style={{ marginTop: '40px' }}
                            onClick={this.addGST.bind(this, index, gst_index)}></i> :
                          <span></span>}
                        <div style={{ overflow: 'scroll', whiteSpace: 'nowrap', display: 'flex' }}>
                          <div style={{ width: '100%' }} title={gst_data.ledger_name}>
                            <AutoComplete
                              hintText="Ledger Name"
                              value={gst_data.ledger_name}
                              errorText={gst_data.ledger_nameErrText}
                              errorStyle={{ fontSize: '12px', color: 'red' }}
                              floatingLabelText='*Ledger Name'
                              searchText={(gst_data.ledger_nameSearchText) ? gst_data.ledger_nameSearchText : gst_data.ledger_name}
                              onUpdateInput={this.handleUpdateInput.bind(this, index, 'ledger_name', gst_index)}
                              onNewRequest={this.handleGstBreakup.bind(this, 'ledger_name', index, gst_index)}
                              dataSource={this.state.ledger_names.map((val, index) => {
                                return {
                                  text: `${val.value}`,
                                  value: (
                                    val.value
                                  ),
                                  id: val.id
                                }
                              })}
                              filter={AutoComplete.caseInsensitiveFilter}
                              textFieldStyle={{ width: '400px' }}
                              listStyle={{ width: 'auto', height: '300px' }}
                              inputStyle={{ marginTop: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                              openOnFocus={true}
                              style={{ width: '400px' }}
                              underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)', width: '400px' }}
                              floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                            />
                          </div>
                          <div>
                            <TextField
                              label="Item Name"
                              placeholder=" Enter item name"
                              value={gst_data.item_name}
                              onChange={this.handleGstBreakup.bind(this, 'item_name', index, gst_index)}
                              margin='normal'
                              style={{ width: '200px', marginLeft: '15px' }}
                              disabled={isItemNameReadOnly(this.state.status)}
                            />
                            <TextField
                              label={`*Amount ${gst_index + 1}`}
                              placeholder=" Enter Amount"
                              type='text'
                              InputProps={{ inputProps: { min: 0 } }}
                              value={gst_data.amount === 0 ? '' : gst_data.amount}
                              onChange={this.handleGstBreakup.bind(this, 'amount', index, gst_index)}
                              margin='normal'
                              style={{ width: '150px', marginLeft: '15px' }}
                              helperText={gst_data.amountErrText}
                              error={gst_data.amountErr}
                            />
                            <TextField
                              label="LDC Amount Limit"
                              placeholder=" Enter LDC Amount Limit"
                              type='number'
                              disabled
                              InputProps={{ inputProps: { min: 0 } }}
                              value={String(gst_data.ldc_amount_limit === 0 ? '' : gst_data.ldc_amount_limit)}
                              margin='normal'
                              style={{ width: '150px', marginLeft: '15px' }}
                            />
                            <TextField
                              label="Deductions"
                              placeholder=" Enter Deductions"
                              type='text'
                              InputProps={{ inputProps: { min: 0 } }}
                              value={gst_data.other_deduction === 0 ? '' : gst_data.other_deduction}
                              onChange={this.handleGstBreakup.bind(this, 'other_deduction', index, gst_index)}
                              style={{ width: '150px', marginLeft: '15px' }}
                              margin='normal'
                            />
                            <TextField
                              label="Discount"
                              placeholder=" Enter discount"
                              type='text'
                              InputProps={{ inputProps: { min: 0 } }}
                              value={gst_data.discount === 0 ? '' : gst_data.discount}
                              onChange={this.handleGstBreakup.bind(this, 'discount', index, gst_index)}
                              margin='normal'
                              style={{ width: '150px', marginLeft: '15px' }}
                              disabled={this.state.status === 'edit'}
                            />
                            <FormControl margin='normal' style={{ marginLeft: '15px' }}>
                              <InputLabel htmlFor="gst_slab">*GST Slab</InputLabel>
                              <Select
                                value={gst_data.gst_slab}
                                onChange={this.handleGstTypeCheck.bind(this, 'gst_slab', index, gst_index)}
                                error={gst_data.gst_slabErr}
                                inputProps={{
                                  name: 'GST Slab',
                                  id: 'gst_slab',
                                }}
                                style={{ width: '150px', textAlign: 'left' }}
                                disabled={this.state.cost_center_entries.gst_type == 'NOT APPLICABLE'}
                              >
                                {
                                  this.state.gst_slabs.map(gst_slab => {
                                    return <MenuItem value={gst_slab}>{gst_slab + '%'}</MenuItem>
                                  })
                                }
                              </Select>
                              <FormHelperText style={{ color: 'red' }}>{gst_data.gst_slabErrText}</FormHelperText>
                            </FormControl>
                            <FormControl margin='normal' style={{ marginLeft: '15px' }}>
                              <InputLabel htmlFor="tds_slab">*TDS Slab</InputLabel>
                              <Select
                                value={gst_data.tds_slab}
                                onChange={this.handleGstBreakup.bind(this, 'tds_slab', index, gst_index)}
                                inputProps={{
                                  name: 'TDS Slab',
                                  id: 'tds_slab',
                                }}
                                error={gst_data.tds_slabErr}
                                style={{ width: '150px', textAlign: 'left' }}
                              >
                                {
                                  this.state.tds_slabs.map(tds_slab => {
                                    return <MenuItem value={tds_slab}>{tds_slab + '%'}</MenuItem>
                                  })
                                }
                              </Select>
                              <FormHelperText style={{ color: 'red' }}>{gst_data.tds_slabErrText}</FormHelperText>
                            </FormControl>
                            <TextField
                              label="Net Payable"
                              disabled
                              type='number'
                              value={gst_data.split_payable_amount === 0 ? '' : gst_data.split_payable_amount}
                              margin='normal'
                              style={{ width: '150px', marginLeft: '15px' }}
                            />
                            <TextField
                              label="Quantity"
                              placeholder=" Enter Quantity"
                              type='number'
                              InputProps={{ inputProps: { min: 0 } }}
                              value={gst_data.quantity === 0 ? '' : gst_data.quantity}
                              onChange={this.handleGstBreakup.bind(this, 'quantity', index, gst_index)}
                              margin='normal'
                              style={{ width: '150px', marginLeft: '15px' }}
                              disabled={this.state.status === 'edit'}
                            />
                            <TextField
                              label="Rate"
                              placeholder=" Enter Rate"
                              type='number'
                              InputProps={{ inputProps: { min: 0 } }}
                              value={gst_data.rate === 0 ? '' : gst_data.rate}
                              onChange={this.handleGstBreakup.bind(this, 'rate', index, gst_index)}
                              margin='normal'
                              style={{ width: '150px', marginLeft: '15px' }}
                              disabled={this.state.status === 'edit'}
                            />
                            <TextField
                              label="Desc"
                              placeholder=" Enter description"
                              value={gst_data.item_description}
                              onChange={this.handleGstBreakup.bind(this, 'item_description', index, gst_index)}
                              margin='normal'
                              style={{ width: '150px', marginLeft: '10px' }}
                            />
                            <TextField
                              label="HSN"
                              placeholder=" Enter HSN"
                              value={gst_data.hsn}
                              onChange={this.handleGstBreakup.bind(this, 'hsn', index, gst_index)}
                              margin='normal'
                              style={{ width: '150px', marginLeft: '15px' }}
                            />
                            <TextField
                              label="SAC"
                              placeholder=" Enter SAC"
                              value={gst_data.sac}
                              onChange={this.handleGstBreakup.bind(this, 'sac', index, gst_index)}
                              margin='normal'
                              style={{ width: '150px', marginLeft: '10px' }}
                            />
                            <FormControl margin='normal' style={{ marginLeft: '15px' }}>
                              <InputLabel htmlFor="currency">INR</InputLabel>
                              <Select
                                value={gst_data.currency}
                                onChange={this.handleGstBreakup.bind(this, 'currency', index, gst_index)}
                                inputProps={{
                                  name: 'Currency',
                                  id: 'currency',
                                }}
                                style={{ width: '150px', textAlign: 'left' }}
                              >
                                {
                                  this.state.currencies.map(currency => {
                                    return <MenuItem value={currency}>{currency}</MenuItem>
                                  })
                                }
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        {gst_data.is_recoverable && (
                          <div
                            style={{
                              display: 'flex',
                              background: 'rgb(255,255,255)',
                              background: 'linear-gradient(270deg, rgba(255,255,255,1) 0%, rgb(117 229 189) 100%)',
                              fontSize: '14px',
                              width: '100%',
                              fontWeight: '500',
                              borderRadius: '5px',
                              padding: '7px',
                              color: '#111111',
                              position: 'absolute',
                              bottom: '-10px',
                              left: '1.5rem'
                            }}
                          >
                            Recoverable Percentage: {gst_data.recoverable_percentage}%
                          </div>
                        )}
                        {/* {this.state.status != 'edit' && <DeleteIcon onClick={this.deleteEntries.bind(this, index, gst_index)} style={{ marginTop: '40px' }} />} */}
                        {<DeleteIcon onClick={this.deleteEntries.bind(this, index, gst_index)} style={{ marginTop: '40px' }} />}
                      </div>
                    </Fragment>
                  )
                })}
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          )
        })}

        {/* {this.state.status != 'edit' && <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginTop: '20px', marginBottom: '50px' }}>
          <Button variant="contained" color="primary" onClick={this.handleDetails.bind(this, 'add')}>
            + Add Cost Center
                </Button>
        </div>} */}
        <div className="zaps-form-actions">
          <Button variant="contained" color="primary" onClick={this.handleDetails.bind(this, 'add')}>
            + Add Cost Center
          </Button>
        </div>
        <div>
          {this.isVendorDefaultorAmount() ? (
            <Fragment>
              <TextField
                label="*Total Defaulter Amount for Deduction"
                value={String(this.state.cost_center_entries.defaultor_amount_deduction && this.state.cost_center_entries.defaultor_amount_deduction > 0 ? this.state.cost_center_entries.defaultor_amount_deduction : '')}
                disabled={this.handleDisableDefaultorAmount()}
                margin='normal'
                type='number'
                style={{ width: '350px', marginBottom: '20px' }}
                onChange={this.handleChange('defaultor_amount_deduction')}
                placeholder='Enter total defaulter amount for deduction'
                error={this.state.defaultor_amount_deductionErr}
                helperText={this.state.defaultor_amount_deductionErrText}
              />
              <ICircledIcon style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={this.openInfoPopOver('Vendor')} />
            </Fragment>
          ) : null}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
          <FormControl>
            <InputLabel htmlFor="is_recoverable">*IS RECOVERABLE</InputLabel>
            <Select
              value={this.state.cost_center_entries.is_recoverable}
              onChange={this.handleChange('is_recoverable')}
              disabled={this.state.status === 'edit'}
              inputProps={{
                name: 'IS RECOVERABLE',
                id: 'is_recoverable',
              }}
              style={{ width: '250px' }}
              error={this.state.is_recoverableErr}
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </Select>
            <FormHelperText style={{ color: 'red' }}>{this.state.is_recoverableErrText}</FormHelperText>
          </FormControl>
        </div>
        {this.state.cost_center_entries.is_recoverable === true &&
          <div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
              <TextField
                label="Amount recoverable (as per ZAPS)"
                placeholder=" Enter Amount recoverable"
                type='number'
                error={this.state.amount_recoverableErr}
                value={this.state.cost_center_entries.amount_recoverable}
                disabled={this.state.status === 'edit'}
                onChange={this.handleChange('amount_recoverable')}
                style={{ width: '250px' }}
                margin='normal'
                helperText={this.state.amount_recoverableErrText}
              />
              <TextField
                label="Amount recoverable (as Per Bill Submission)"
                type='number'
                value={this.state.cost_center_entries.billSub_amount_recoverable}
                disabled={true}
                style={{ width: '350px', marginLeft: '20px' }}
                margin='normal'
              />
              <FormControl margin='normal' style={{ marginLeft: '20px' }}>
                <InputLabel htmlFor="as_per_agreement">As per Agreement</InputLabel>
                <Select
                  value={this.state.cost_center_entries.as_per_agreement}
                  error={this.state.as_per_agreementErr}
                  onChange={this.handleChange('as_per_agreement')}
                  disabled={this.state.status === 'edit'}
                  inputProps={{
                    name: 'As per Agreement',
                    id: 'as_per_agreement',
                  }}
                  style={{ width: '250px', textAlign: 'left' }}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
                <FormHelperText style={{ color: 'red' }}>{this.state.as_per_agreementErrText}</FormHelperText>
              </FormControl>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
              {this.state.cost_center_entries.as_per_agreement === false && <div>
                <div >
                  <TextField
                    label=" Any proof"
                    value={this.state.cost_center_entries.amt_recoverable_proof_file_name}
                    disabled={true}
                    margin='normal'
                    style={{ width: '250px' }}
                    //   errorText={this.state.mouFileNameError}
                    error={this.state.proofErr}
                    helperText={this.state.proofErrText}

                  />
                  <label for={'file-upload'} className='custom-file-upload' style={{ border: '1px solid #ccc', display: 'inline-block', padding: '9px 12px', cursor: 'pointer', height: '16px', marginLeft: '5px' }}>
                    Browse
                  </label>
                  <input 
                    id={'file-upload'} 
                    type="file" 
                    onClick={(event) => event.target.value = null} 
                    disabled={this.state.status === 'edit'} 
                    onChange={this.amtRecoverableFileHandler.bind(this)} style={{ display: "none" }} 
                  />
                </div>
              </div>}
            </div>
          </div>}
        <TextField
          label="Comments for recoverable amount"
          placeholder=" Enter comments"
          value={this.state.cost_center_entries.recoverable_amount_remarks}
          disabled={this.state.status === 'edit'}
          margin='normal'
          onChange={this.handleChange('recoverable_amount_remarks')}
          style={{ width: '520px' }}
          helperText={this.state.recoverable_amount_remarksErrText}
          error={this.state.recoverable_amount_remarksErr}
        />
        <div className="zaps-form-actions">
          {this.state.status != 'edit' && <Button variant="contained" color="primary" onClick={this.handleClear.bind(this)}
            buttonStyle={{ backgroundColor: 'red' }}>Clear</Button>}
          <Button variant="contained" color="primary"
            onClick={this.props.handleBack.bind(this, this.state.cost_center_entries)} buttonStyle={{ backgroundColor: 'red' }} style={{ marginLeft: '20px' }}>Back</Button>
          <Button style={{ marginLeft: '20px' }} onClick={this.handleDetails.bind(this, 'next')} variant="contained" color="primary">Next</Button>
        </div>
        {this.state.dialogBox === true && <DialogBox AlertText={this.state.dialogBoxText}
          handleYes={(e) => {
            if (this.state.dialogBoxStatus === 'deleteCostCenters') {
              this.handleYes()
            }
            else if (this.state.dialogBoxStatus === 'deleteEntries') {
              this.removeEntries()
            }

          }} handleNo={this.handleNo.bind(this)} />}
        <Popover
          id="simple-popper"
          open={this.state.popOverConfig.open}
          anchorEl={this.state.popOverConfig.anchorEl}
          onClose={this.handlePopOverClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
        <div  style={{ padding: '6px', border: '1px solid black', borderRadius: '4px', width:'300px'}}>
        <span style={{ margin: '5px' }}>{this.state.popOverConfig.content}</span><br/><br/>
        <span style={{ margin: '5px' }}>{this.state.popOverConfig.auxContent}</span>
        </div>
        </Popover>
        <Dialog
          open={this.state.showRcmAwarenessModal}
          onClose={() => this.handleClose()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <div style={{ textAlign: 'center', border: '1px dashed #FF0000' }}>
              <p>{this.state.showRcmAwarenessText.message}</p>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.vendorLdcModal}
          onClose={() => this.setState({
            vendorLdcModal: false
          })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <div style={{ textAlign: 'center', border: '1px dashed #FF0000' }}>
              <List>
                {this.state.vendorLdcModalData.map((data, index) => (
                  <ListItem key={data.name}>
                    <ListItemText style={{ minWidth: '240px' }} primary={data.name} />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={data.renderVal} />
                  </ListItem>
                ))}
              </List>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.showConfirmationDialog}
          onClose={this.handleCloseConfirmationDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <div style={{ textAlign: 'center', border: '1px dashed #FF0000', padding: '0 10px 15px 10px' }}>
              <p>Please review all the Cost Centers, Ledgers, Amounts, GST, and TDS thoroughly before proceeding.</p>
              <Button onClick={this.handleCloseConfirmationDialog} variant="contained" color="primary">Close</Button>
            </div>
          </DialogContent>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          autoHideDuration={2000}
          onClose={this.handleCloseSnack.bind(this)}
          message={this.state.snackText}
        />
      </MuiThemeProvider>
    )
  }
}

export default PaymentRequest



// WEBPACK FOOTER //
// ./src/components/CostCenterDetails.js